import { Result } from "antd"
import "./FormDocuSign.css"


const FormDocuSignConnectFailed = () => {
    return (
        <>
            <nav className="verify-welcome-nav">
                <div className="verify-logo">Advisors Reserve</div>
            </nav>
            <div className="docusign-connect-result-container">
                <Result
                    status="error"
                    title="DocuSign Connection Failed!"
                    subTitle="Please try again or contact admin."
                    extra={[]}
                />
            </div>
        </>
    )
}

export default FormDocuSignConnectFailed